// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/search/search_domain.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/search/search_domain.proto.
 */
export const file_proto_model_search_search_domain = /*@__PURE__*/
  fileDesc("CiZwcm90by9tb2RlbC9zZWFyY2gvc2VhcmNoX2RvbWFpbi5wcm90bxIGY2FybWVuKrsBCgxTZWFyY2hEb21haW4SHQoZU0VBUkNIX0RPTUFJTl9VTlNQRUNJRklFRBAAEhcKE1NFQVJDSF9ET01BSU5fUExBQ0UQARIcChhTRUFSQ0hfRE9NQUlOX1JFU1RBVVJBTlQQAhIgChxTRUFSQ0hfRE9NQUlOX1RSQU5TUE9SVEFUSU9OEAMSGgoWU0VBUkNIX0RPTUFJTl9BQ1RJVklUWRAEEhcKE1NFQVJDSF9ET01BSU5fSE9URUwQBUIoWiZnaXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbGIGcHJvdG8z");

/**
 * Describes the enum carmen.SearchDomain.
 */
export const SearchDomainSchema = /*@__PURE__*/
  enumDesc(file_proto_model_search_search_domain, 0);

/**
 * Search domains for intent detection and universal search
 *
 * @generated from enum carmen.SearchDomain
 */
export const SearchDomain = /*@__PURE__*/
  tsEnum(SearchDomainSchema);

